import request from '@/utils/request'

// 查询工单列表
export function queryTaskWork(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/work.queryTaskWork',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve({
        data: res.data,
        total: res.total
      })
    }).catch(error => {
      reject(error)
    })
  })
}